const OFFSET_SCOPE_CATEGORIES = [
  'Scope 1',
  'Scope 2 - Location-Based',
  'Scope 2 - Market-Based',
  'Scope 3 - Business Travel',
  'Scope 3 - Employee Commuting',
  'Scope 3 - Upstream Transportation and Distribution',
  'Scope 3 - Waste Generated in Operations'
];

export default OFFSET_SCOPE_CATEGORIES;
